import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const canadaBest10StylesCA: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#B91C1C]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#B91C1C]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#1D4ED8] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#DBE9FE]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#1E40AF]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#FB923C] hover:border-[#FB923C] hover:bg-[#FB923C] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#FB923C]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#BFDBFE]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#B91C1C]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#B91C1C]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#BFDBFE]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#1E40AF] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#1E40AF] text-[#1E40AF] [&>svg>path]:stroke-[#1E40AF] [&>svg>g>path]:stroke-[#1E40AF] [&>svg>path]:fill-[#1E40AF] [&>svg>g>path]:fill-[#1E40AF]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#1E40AF]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#B91C1C]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#DBE9FE]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#BFDBFE]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#DBE9FE]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#B91C1C] [&>.explore-icon-fill]:!fill-[#DBE9FE] [&>g>.explore-icon-fill]:!fill-[#DBE9FE]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#DBE9FE] [&>.vector-top>path]:fill-[#B91C1C] [&>.vector-bottom>path]:fill-[#B91C1C]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-red-700 [&>div>svg>path]:fill-red-700 bg-red-50',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-red-600',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-red-200',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-black',
  LISTPAGE_BADGE_WINNER_BG: 'bg-red-600',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-red-600',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#BFDBFE]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-[#1E40AF]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#BFDBFE]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#1E40AF]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#BFDBFE]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#2C0065] ',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#2C0065]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#BFDBFE]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white ',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#1E40AF]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#1E40AF] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#1E40AF] text-[#1E40AF] [&>svg>path]:stroke-[#1E40AF] [&>svg>g>path]:stroke-[#1E40AF] [&>svg>path]:fill-[#1E40AF] [&>svg>g>path]:fill-[#1E40AF]',
  LISTPAGE_BUTTON_LINK: 'text-[#1E40AF]',
  LISTPAGE_ANCHOR_LINK: 'text-[#1E40AF]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#1E40AF]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#1E40AF]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#1E40AF]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#1E40AF] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#1E40AF] text-[#1E40AF]  [&>svg>path]:stroke-[#1E40AF] [&>svg>g>path]:stroke-[#1E40AF] [&>svg>path]:fill-[#1E40AF] [&>svg>g>path]:fill-[#1E40AF]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#1E40AF]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#1E40AF]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#1E40AF]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#1E40AF]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#3B82F6]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#1E40AF]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#BFDBFE] [&>.vector-top>path]:fill-[#1E40AF] [&>.vector-bottom>path]:fill-[#1E40AF]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-[#F7F7F7]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#BFDBFE] [&>circle]:stroke-[#BFDBFE] [&>path]:fill-[#1E40AF]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#BFDBFE]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#1E40AF]',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#458DFA4D] data-[focus]:text-black',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#458DFA4D] text-[#458DFA]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#458DFA]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',

  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-red-600',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-white',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-white [&>.explore-icon-fill]:!fill-red-600 [&>g>.explore-icon-fill]:!fill-red-600',

  UTILS_MAIN_CONTAINER: 'content-container',
}
